import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import WelcomeScreen from './WelcomeScreen';
import PasswordLoginScreen from './PasswordLoginScreen';
import RegisterScreen from './RegisterScreen';
import HomeScreen from './HomeScreen';
import PhotoScreen from './PhotoScreen';
import SuccessScreen from './SuccessScreen';
import ErrorScreen from './ErrorScreen';
import HistoryScreen from './HistoryScreen';
import FAQScreen from './FAQScreen';
import ProtectedRoute from './components/ProtectedRoute';
import UserManagementScreen from './UserManagementScreen';
import AdminRoute from './components/AdminRoute';
import ResetPasswordScreen from './ResetPasswordScreen';
import ResetPasswordSuccessScreen from './ResetPasswordSuccessScreen';
import ResetPasswordErrorScreen from './ResetPasswordErrorScreen';


function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Telas públicas */}
        <Route path="/" element={< WelcomeScreen />} />
        <Route path="/login-password" element={<PasswordLoginScreen />} />
        <Route path="/register" element={<RegisterScreen />} />
        <Route path="/reset-password" element={<ResetPasswordScreen />} />
        <Route path="/reset-password-success" element={<ResetPasswordSuccessScreen />} />
        <Route path="/reset-password-error" element={<ResetPasswordErrorScreen />} />


        {/* Rotas protegidas por login */}
        <Route element={<ProtectedRoute />}>
          <Route path="/home" element={<HomeScreen />} />
          <Route path="/photo" element={<PhotoScreen />} />
          <Route path="/success" element={<SuccessScreen />} />
          <Route path="/error" element={<ErrorScreen />} />
          <Route path="/historico" element={<HistoryScreen />} />
          <Route path="/faq" element={<FAQScreen />} />
          
          {/* Rotas de administrador */}
          <Route element={<AdminRoute />}>
            <Route path="/manage-users" element={<UserManagementScreen />} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
